import ENV from "../config";

export default {
  ...ENV,
  AWS_USER_POOLS_ID: ENV.AWS_EXTERNAL_USER_POOLS_ID || "eu-west-2_BOXY4VfMJ",
  AWS_USER_POOLS_WEB_CLIENT_ID: ENV.AWS_EXTERNAL_USER_POOLS_WEB_CLIENT_ID || "3gko02lmlhvpfqjsse0vb07bvs",
};
